import { createReducer } from "@reduxjs/toolkit";

import {
  getScheduledStreams,
  getScheduledStreamsSuccess,
  getScheduledStreamsFailure,
} from "./actions";

/**
 * @property {object[]} livestreams array of scheduled livestreams
 * @property {number} totalCount total number of scheduled livestreams
 * @property {boolean} isLoading flag to indicate if the request is in progress
 * @property {string | null} error error message
 * @property {number | null} nextOffset offset to fetch the next set of scheduled livestreams
 */
const initialState = {
  livestreams: [],
  totalCount: null,
  isLoading: true,
  error: null,
  nextOffset: null,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getScheduledStreams.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getScheduledStreamsSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      error: initialState.error,
      isLoading: false,
    }))
    .addCase(getScheduledStreamsFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }));
});
